import * as React from 'react';
import type { SVGProps } from 'react';

const SvgIconPro = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={30} height={31} fill="none" {...props}>
    <path
      fill="#EF4136"
      d="M30 15.214C30 6.811 23.283 0 15 0 6.715 0 0 6.81 0 15.214c0 8.4 6.715 15.211 15 15.211 8.284 0 15-6.81 15-15.21Z"
    />
    <path
      fill="#fff"
      d="m19.924 19.646-3.427-.822V11.6l3.426-.823a.804.804 0 0 0 .613-.784V8.559H9.464v1.434c0 .373.253.698.612.784l3.425.823v7.224l-3.424.822a.805.805 0 0 0-.613.785v1.434h11.072v-1.434a.805.805 0 0 0-.612-.785Z"
    />
  </svg>
);
export default SvgIconPro;
